import yup from '@fourthwall/utils/dist/yup';
export const validationSchema = yup.object().shape({
    googleAnalyticsTrackingId: yup
        .string()
        .trim()
        .matches(/^G-[A-Z0-9]{10}$/, 'Google Tracking ID is not in a valid format'),
    facebookPixelId: yup
        .string()
        .trim()
        .matches(/^[0-9]{15,16}$/, 'Facebook Pixel ID is not in a valid format'),
    tiktokPixelId: yup
        .string()
        .trim()
        .matches(/^[A-Z0-9]{20}$/, 'TikTok Pixel ID is not in a valid format'),
});
